import { convertToPrice } from "../../utils/functions/currencies";

export const PriceBodyTemplate = (rowData: any) => {
  return (
    <div className="font-medium text-900">{convertToPrice(rowData.price)}</div>
  );
};
